<template>
  <div id="content" class="screenDiv" >
    <Row>
      <Col span="24" style="padding-bottom:10px;">
      <div class="gradeBox" style="padding-top:10px;">
        <div class="grade">年级：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseGrade?'':'isChose'" @click="choseAllGrade()">全部</div>
          <div class="gradeName" v-for="(grade,index) in gradeInfo" :key="grade.id" :class="grade.id==isGrade?'bg':''"
            @click="choseGrade(index,grade.id)">{{grade.name}}</div>
        </div>
      </div>
      <div class="gradeBox">
        <div class="grade">学科：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseSubject?'':'isChose'" @click="choseAllSubject()">全部</div>
          <div class="gradeName" v-for="(subject,index) in subjectInfo" :key="subject.id" :class="subject.id==isSubject?'bg':''"
            @click="choseSubject(index,subject.id)">{{subject.name}}</div>
        </div>
      </div>
      <div class="gradeBox" v-if="isPackage">
        <div class="grade">册别：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseVolume?'':'isChose'" @click="choseAllVolume()">全部</div>
          <div class="gradeName" v-for="(volume,index) in volumeInfo" :key="volume.id" :class="volume.id==isVolume?'bg':''"
            @click="choseVolume(index,volume.id)">{{volume.name}}</div>
        </div>
      </div>
      <div class="gradeBox" v-if="isPackage">
        <div class="grade">类型：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseType?'':'isChose'" @click="choseAllType()">全部</div>
          <div class="gradeName" v-for="(type,index) in typeInfo" :key="type.id" :class="type.id==isType?'bg':''"
            @click="choseType(index,type.id)">{{type.name}}</div>
        </div>
      </div>
      <div class="gradeBox">
        <div class="grade">版本：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseVersion?'':'isChose'" @click="choseAllVersion()">全部</div>
          <div class="gradeName" v-for="(version,index) in versionInfo" :key="version.id" :class="version.id==isVersion?'bg':''"
            @click="choseVersion(index,version.id)">{{version.name}}</div>
        </div>
      </div>
      <div class="gradeBox" v-if="isPackage">
        <div class="grade" style="padding-left:10px;">更新时间：</div>
        <div class="">
          <DatePicker @on-change="changeTime" type="datetimerange" size="small" placement="top" placeholder="选择起始日期"
            style="width: 280px;margin-left:50px;"></DatePicker>
        </div>
      </div>
      </Col>
      <Col span="0">
      <div class="openScreen" @click="showSreen()">
        <div class="openScreenBox">
          {{isOpenScreen?'展开':'收起'}}
          <img class="isOpenImg" :src="isOpenImgSrc" alt="">
        </div>

      </div>
      </Col>
    </Row>

  </div>
</template>
<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js'
  export default {
    name: 'PackageClassScreen',
    props: {
      isShowStyle: {
        type: Boolean,
        default: false
      },
      isPackage: {
        type: Boolean,
        default: false
      },
      fromIndexRes: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        urlHttp: '/testIp',
        gradeInfo: null, //年级 信息
        subjectInfo: null, //学科 信息
        versionInfo: null, //版本 信息
        materialInfo: null, //教材 信息
        volumeInfo: null,
        gradeId:null,
        subjectId:null,
        versionId:null,
        websiteId:0,
        list:null,
        isChoseGrade: false, //是否选择 年级 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseSubject: false, //是否选择 学科 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseVersion: false, //是否选择 版本 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseMaterial: false, //是否选择 教材 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseStyle: false, //是否选择 类型 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseVolume: false, //是否选择 册别 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseType: false, //是否选择 类型（备课包） 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isGrade: null, //年纪筛选条件 初始默认选择全部
        isSubject: null, //学科筛选条件 初始默认选择全部
        isVersion: null, //版本筛选条件 初始默认选择全部
        isMaterial: null, //教材筛选条件 初始默认选择全部
        isStyle: null, //教材类型条件 初始默认选择全部
        isVolume: null, //册别类型条件 初始默认选择全部
        isType: null, //类型（备课包)条件 初始默认选择全部
        isOpenScreen: true,
        isOpenImgSrc: '/static/images/open.png',
        screenDiv: '150px', //筛选框初始高度
        typeInfo: [{
            name: '同步课',
            id: '0'
          },
          {
            name: '专题课',
            id: '1'
          }
        ]
      }
    },
    mounted() {
      const that = this;
      this.selectQcrPublic('grade_id',null,null);
      //this.getGradeData(that.list);
      //this.getSubjectData();
      //this.getVersionData();
      //this.getVolumeInfoData()
       console.log(this.fromIndexRes,this.isSubject,"jjjjjjjjjj")
      if(this.fromIndexRes != null){
        if(this.fromIndexRes.isFromIndexSyn == 'OpenClass'){
          this.subjectId = this.fromIndexRes.subjectId;
          this.isSubject = this.fromIndexRes.subjectId;
          this.isChoseSubject = true;
          this.$nextTick(() => {
              bus.$emit('openSubjectId',that.fromIndexRes.subjectId);
          })
          this.fromIndexRes.isFromIndexSyn = null;
        }else {
          this.isChoseSubject = false;
        }
      }
    },
  methods: {
    //获取级联年级信息
    selectQcrPublic(columnName,gradeId,subjectId){
      let that = this;
      const url = '/axt-data/qcr/selectQcrPublic';
      if(localStorage.getItem('websiteId') == undefined || localStorage.getItem('websiteId') == null){
        that.websiteId = 0;
      }else{
        that.websiteId = localStorage.getItem('websiteId');
      }
      let params = {
        pageNo:1,
        pageSize:100,
        websiteId:that.websiteId,
        gradeId:gradeId,
        subjectId:subjectId,
        columnName:columnName
      }

      // console.log(params,"paramsparams")
      api.getListAPI(url,params).then(res => {
        //console.log(res,"jjjjjjjjjjjjjjjjj")
        if(res.data.message == 'success'){
          let list = res.data.data;
          if(list.length == 0) list = null;
          if(columnName == 'grade_id') that.getGradeData(list)
          if(columnName == 'subject_id') that.getSubjectData(list)
          if(columnName == 'version_id') that.getVersionData(list)
        }
       }).catch(err => {console.log(err)})
    },
    //获取年级信息
    getGradeData(list) {
      let that = this;
      const url = '/axt-crm/grade/page';
      var params = {
        status: 1,
        pageSize:100,
        ids:list,
        orderBys: [
        		{
        			direction: 'asc',
        			field: 'sort_id'
        		}
        	]
      };
      api.postFormAPI(url, params).then(res => {
        //数据处理
         this.gradeInfo = res.data.data.rows;
         this.selectQcrPublic('subject_id',that.gradeId)
      }).catch(err => {
        console.log(err)
      })
    },
    //获取学科信息
    getSubjectData(list) {
		if(list.indexOf(this.subjectId) == -1){
		    this.subjectId = null;
		    this.isSubject = null;
		    this.isChoseSubject = false;
		}
      let that = this;
      const url = '/axt-crm/subject/page';
      var params = {
        status: 1,
        pageSize:100,
        ids:list,
        orderBys: [
        		{
        			direction: 'asc',
        			field: 'SORT_ID'
        		}
        	]
      };
      api.postFormAPI(url, params).then(res => {
        that.subjectInfo = res.data.data.rows;
        this.selectQcrPublic('version_id',that.gradeId,that.subjectId)
        bus.$emit('openSubjectId', that.subjectId);
      }).catch(err => {
        console.log(err)
      })
    },
    //获取版本信息
    getVersionData(list) {
      if(list.indexOf(this.versionId) == -1){
          this.versionId = null;
          this.isVersion = null;
          this.isChoseVersion = false;
      }
      let that = this;
      const url = '/axt-crm/version/list';
      var params = {
        status: 1,
        ids:list,
      };
      api.postFormAPI(url, params).then(res => {
        that.versionInfo = res.data.data;

        bus.$emit('openVersionId', that.versionId);
        // console.log(that.versionInfo)
      }).catch(err => {
        console.log(err)
      })
    },
    //获取册别信息
    getVolumeInfoData() {
      let that = this;
      const url = '/axt-crm/term/list';
      var params = {
        status: 1
      };
      api.postFormAPI(url, params).then(res => {
        //console.log(res.data.data,"kkkkkkkk")
        that.volumeInfo = res.data.data;
      }).catch(err => {
        console.log(err)
      })
    },
    //选择日期
    changeTime(name) {
      bus.$emit('choseTime', name);
    },
    //点击年级筛选条件 字体变色
    choseGrade(index, gradeId) {
      //console.log(index,gradeId)
      this.isGrade = gradeId;
      this.gradeId = gradeId;
      this.isChoseGrade = true; // 选择筛选条件后 全部按钮置灰
      this.selectQcrPublic('subject_id',gradeId)
      if (this.isPackage) {
        bus.$emit('packageGradeId', gradeId);
        return
      }
      bus.$emit('openGradeId', gradeId)
    },
    choseAllGrade() {
      this.isGrade = null;
      this.isChoseGrade = false; // 选择筛选条件后 全部按钮置灰
      this.gradeId = null;
      this.selectQcrPublic('subject_id',null)
      if (this.isPackage) {
        bus.$emit('packageGradeId', null);
        return
      }
      bus.$emit('openGradeId', null)
    },
    //点击学科筛选条件 字体变色
    choseSubject(index, subjectId) {
      this.isSubject = subjectId;
      this.isChoseSubject = true;
      this.subjectId = subjectId;
      this.selectQcrPublic('version_id',this.gradeId,subjectId)
      if (this.isPackage) {
        bus.$emit('packageSubjectId', subjectId);
        return
      }
      bus.$emit('openSubjectId', subjectId)
    },
    choseAllSubject() {
      this.isSubject = null;
      this.isChoseSubject = false;
      this.subjectId = null;
      this.selectQcrPublic('version_id',this.gradeId,null)
      if (this.isPackage) {
        bus.$emit('packageSubjectId', null);
        return
      }
      bus.$emit('openSubjectId', null)
    },
    //点击册别筛选条件 字体变色
    choseVolume(index, volumeId) {
      this.isVolume = volumeId;
      this.isChoseVolume = true;
      if (this.isPackage) {
        bus.$emit('packageVolumeId', volumeId);
        return
      }
      bus.$emit('volumeId', volumeId)
    },
    choseAllVolume() {
      this.isVolume = null;
      this.isChoseVolume = false;
      if (this.isPackage) {
        bus.$emit('packageVolumeId', null);
        return
      }
    },
    //点击版本筛选条件 字体变色
    choseVersion(index, versionId) {
      this.isVersion = versionId;
      this.isChoseVersion = true;
      this.versionId = versionId;
      if (this.isPackage) {
        bus.$emit('packageVersionId', versionId);
        return
      }
      bus.$emit('openVersionId', versionId)
    },
    choseAllVersion() {
      this.isVersion = null;
      this.versionId = null;
      this.isChoseVersion = false;
      if (this.isPackage) {
        bus.$emit('packageVersionId', null);
        return
      }
      bus.$emit('openVersionId', null)
    },
    //点击类型筛选条件 字体变色
    choseType(index, typeId) {
      this.isType = typeId;
      this.isChoseType = true;
      if (this.isPackage) {
        bus.$emit('packageTypeId', typeId);
        return
      }
      bus.$emit('typeId', versionId)
    },
    choseAllType() {
      this.isType = null;
      this.isChoseType = false;
      if (this.isPackage) {
        bus.$emit('packageTypeId', null);
        return
      }
    },
    // 展开 收起
    showSreen() {
      this.isOpenScreen = !this.isOpenScreen;
      if (!this.isOpenScreen) {
        this.screenDiv = 'auto'
        this.isOpenImgSrc = '/static/images/close.png'
      } else {
        this.screenDiv = '150px'
        this.isOpenImgSrc = '/static/images/open.png'
      }
    }
  }
  }
</script>
<style lang="">
  .screenDiv {
    width: 100%;
    border: 1px solid #DADADA;
    border-radius: 6px;
    color: #666;
    font-size: 14px;
    /* overflow: hidden; */
  }

  .gradeBox {
    width: 100%;
    min-height: 30px;
    padding: 5px 0 0 0;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    line-height: 30px;
    white-space: normal；
  }

  .gradeBox .ivu-input-with-suffix {
    padding-right: 0px;
  }

  .gradeBox .ivu-input-suffix:hover {
    cursor: pointer;
  }

  .gradeNameBox {
    overflow: hidden;
  }

  .grade {
    float: left;
    min-width: 70px;
    padding-left: 5px;
  }

  .gradeName {
    float: left;
    min-width: 45px;
    margin: 0 10px;
    padding: 0 5px;
    text-align: left;
  }

  .gradeName:hover {
    cursor: pointer;
    color: #343434;
    border-radius: 5px;
    background: #EEF5FF;
  }

  .isChose {
    color: #3683FF;
  }

  .openScreen {
    width: 100%;
    min-height: 130px;
    position: relative;
    color: #3583FF;
  }

  .openScreenBox {
    position: absolute;
    bottom: 10px;
    right: 30px;
  }

  .openScreenBox:hover {
    cursor: pointer;
  }

  .isOpenImg {
    width: 14px;
    height: 9px;
  }

  .bg {
    color: #3583FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/PackageScreen/OpenScreen.vue